import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableLoadErrorIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 170,
	viewBox: "0 0 160 170",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#tableLoadErrorClip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M81.1344 15.3772C83.0799 11.4553 87.0741 8.9695 91.452 8.9557C95.8292 8.94207 99.8386 11.4029 101.809 15.312C116.41 44.2862 142.697 96.452 156.14 123.128C157.943 126.705 157.765 130.961 155.67 134.375C153.574 137.788 149.861 139.874 145.855 139.887C117.963 139.974 65.7626 140.138 37.8698 140.225C33.8647 140.238 30.1382 138.175 28.0219 134.775C25.905 131.374 25.7003 127.12 27.4805 123.532C40.7558 96.7714 66.7159 44.4418 81.1344 15.3772Z",
			fill: "currentColor",
			fillOpacity: .14
		}), /* @__PURE__ */ _jsx("path", {
			d: "M91.8476 119.501C88.8945 119.511 86.5208 118.709 84.727 117.096C82.9327 115.483 82.0317 113.427 82.0241 110.928C82.0165 108.43 82.9041 106.354 84.6877 104.701C86.4714 103.049 88.8399 102.218 91.793 102.209C94.6892 102.2 97.0348 103.016 98.8288 104.657C100.623 106.298 101.524 108.368 101.532 110.868C101.539 113.31 100.651 115.357 98.8675 117.009C97.0841 118.661 94.7439 119.493 91.8476 119.501ZM100.678 55.6684L98.8455 96.3086L84.6191 96.3529L82.5328 55.7251L100.678 55.6684Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "tableLoadErrorClip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 160,
			height: 169.828,
			fill: "white"
		})
	}) })]
});
export default SvgTableLoadErrorIllustration;
